// DO NOT EDIT — generated from
//   core/renderer/doit_overlay/constants.py
// by
//   scripts/export_overlay_constants.py
//
// Regenerate with:
//   python scripts/export_overlay_constants.py
// (also runs automatically via apps/overlay-tool predev/prebuild hooks)


// --- Fractional coordinates (relative to canvas short_edge) ---
export const LOGO_WIDTH_FRAC = 0.384;
export const LOGO_PAD_X_FRAC = 0.034;
export const LOGO_PAD_Y_FRAC = 0.031;
export const HASHTAG_HEIGHT_FRAC = 0.047;
export const HASHTAG_PAD_X_FRAC = 0.04;
export const HASHTAG_PAD_Y_FRAC = 0.048;
export const HASHTAG_FONT_FRAC = 0.62;
export const HASHTAG_PADDING_X_FRAC = 0.95;

// --- Chip style presets ---
export interface ChipStylePreset {
  font_frac: number;
  padding_x_frac: number;
}
export const CHIP_STYLE_PRESETS: Record<string, ChipStylePreset> = {
  "default": {"font_frac": 0.62, "padding_x_frac": 0.95},
  "tight": {"font_frac": 0.62, "padding_x_frac": 0.85}
} as const;
export const CHIP_STYLE_CHOICES: readonly string[] = ["default", "tight"] as const;

// --- Layout / variant catalogues ---
export const MIN_WIDTH_PX: Record<string, number> = {
  "DOIT_01": 132,
  "DOIT_02": 57,
  "DOIT_03": 170,
  "DOIT_07": 132,
  "DOIT_08": 76,
  "DOIT_09": 57
} as const;
export const LAYOUT_CHOICES: readonly string[] = ["DOIT_01", "DOIT_02", "DOIT_03", "DOIT_07", "DOIT_08", "DOIT_09"] as const;
export const VARIANT_CHOICES: readonly string[] = ["color", "black", "inverted", "kanji_inverted", "dark_standard"] as const;

// --- Theme palette (003 §2-3) ---
export const THEME_COLORS: Record<string, string> = {
  "future_life": "#7C3AED",
  "tech_story": "#16A34A",
  "history_today": "#DC2626",
  "tech_charge": "#D97706",
  "tech_everyday": "#1E3A8A",
  "tech_news": "#0891B2"
} as const;
export const THEME_CHOICES: readonly string[] = ["future_life", "tech_story", "history_today", "tech_charge", "tech_everyday", "tech_news"] as const;

// --- Batch I/O constants ---
export const OUTPUT_INFIXES: readonly string[] = [".logo-", ".tag-", ".verify-"] as const;

// --- Type aliases ---
export type Layout = (typeof LAYOUT_CHOICES)[number];
export type Variant = (typeof VARIANT_CHOICES)[number];
export type ChipStyle = (typeof CHIP_STYLE_CHOICES)[number];
export type ThemeKey = (typeof THEME_CHOICES)[number];
